export default () => {
  return {
    isRequestingGeolocation: false,

    latestGeolocation: null,

    geolocationCallback: null,
  };
};
